import React, { FC } from 'react'
import { useExperimentString } from '@moonpig/web-core-eppo/browser'
import { FilterToggle } from '..'
import { useSearchStore } from '../../../../store/SearchStore'
import { FilterSource } from '../../../../types'
import { InvertedFilterToggle } from '../../../../services/types/services'

type Props = {
  /** Filter object */
  filter: InvertedFilterToggle
}

export const RudeToggle: FC<Props> = ({ filter }) => {
  const toggleFilter = useSearchStore(store => store.toggleFilter)

  const isQuickFiltersExperiment =
    useExperimentString('search-use-dropdown-filters-v2', {
      fallback: 'disabled',
    })?.toLowerCase() === 'enabled'

  const onChange = () => {
    toggleFilter({
      filter,
      select: !filter.isSelected,
      source: FilterSource.Toggle,
    })
  }

  return (
    <FilterToggle
      filter={filter}
      scaledDown={isQuickFiltersExperiment}
      onChange={onChange}
    />
  )
}
